import { useEffect } from 'react'

function useRteSizeListener({ toolbarSizeRef, path }) {
  useEffect(() => {
    if (!toolbarSizeRef.current) return

    if (window === window.parent) return

    if (window.postRobot && path) {
      window.postRobot.sendToParent(`rteToolbarLoaded-${path}`, {
        height: getComputedStyle(toolbarSizeRef.current).height
      })
    }
  }, [!!window.postRobot, path])
}

export default useRteSizeListener
